module.exports = __webpack_public_path__ + "img/Sales Icon - white.7fcce3e0.svg";